import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { meetingsPausedMessageOf } from '../utils/meetings-pause';
import { EngagementMeetingProposalContract } from '../models/engagement-meeting-proposal-contract';

export const FetchEngagementMeetingProposals = createAsyncThunk(
    'engagementMeetings/fetchMeetingProposals',
    async (engagementId: number, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.get(
                `/api/Marketplace/Engagements/${engagementId}/MeetingScheduling`
            );

            if (response.status !== 200) {
                createNotification(
                    meetingsPausedMessageOf(response) ?? 'Could not fetch meeting proposals at the moment.',
                    'error'
                );
                throw Object.assign(new Error('Failed to fetch meeting proposals'), { isAnnounced: true });
            }

            return response.data as EngagementMeetingProposalContract[];
        } catch (error: any) {
            if (!error?.isAnnounced) {
                createNotification(
                    'An error occurred while fetching meeting proposals.',
                    'error'
                );
            }
            throw error;
        }
    }
);